import { ComponentType, useEffect, useState } from "react";
import { User } from "firebase/auth";
import { auth } from "../../../lib/firebase";
import { LoginForm } from "./LoginForm";

export function withAuth(Component: ComponentType<any>) {
  return function AuthWrapper(props: any) {
    const [user, setUser] = useState<User | null>(auth.currentUser);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      // Listen for Firebase auth state changes
      const unsubscribe = auth.onAuthStateChanged((user) => {
        setUser(user);
        setLoading(false);
      });

      return unsubscribe;
    }, []);

    if (loading) {
      return <div>Loading...</div>;
    }

    if (!user) {
      return <LoginForm />;
    }

    // Firebase user is passed to the component
    return <Component {...props} user={user} />;
  };
}
